import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Layout/Header';
import { Footer } from './components/Layout/Footer';
import { HomePage } from './pages/HomePage';
import { ShopPage } from './pages/ShopPage';
import { ProductPage } from './pages/ProductPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/shop" element={<ShopPage data-id="element-8" />} data-id="element-7" />
            <Route path="/product/:id" element={<ProductPage data-id="element-10" />} data-id="element-9" />
            <Route path="/cart" element={<CartPage data-id="element-12" />} data-id="element-11" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-14" />} data-id="element-13" />
            <Route path="/about" element={<AboutPage data-id="element-16" />} data-id="element-15" />
            <Route path="/contact" element={<ContactPage data-id="element-18" />} data-id="element-17" />
          </Routes>
        </main>
        <Footer data-id="element-19" />
      </div>
    </Router>;
}